import gql from 'graphql-tag';

const mutation = gql`
  mutation DietGenerate($request: DietJoInputType!) {
    me {
      dietGenerate(request: $request) {
        ... on BasicMutationSuccess {
          code
          __typename
        }

        ... on ValidationException {
          code
          __typename
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;

export default mutation;
